import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllEvents, getEventRequestStatus, createEventRequest, deleteEvent, getAgentStatus } from "../services/eventService";
import "./EventList.css";
import NavUser from "../components/NavUser";
import SEO from "../components/SEO";

const EventList = () => {
  const [events, setEvents] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const roleId = user?.role_id;  // 3
  const userId = user?.id;
  const [agentStatus, setAgentStatus] = useState(null);





  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getAllEvents();
        setEvents(data);
      } catch (err) {
        console.error("Error fetching events:", err);
      }
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchRequestStatus = async () => {
      if (roleId === 1 && agentStatus !== 4) return; // agent not approved
      if (roleId === 2 || roleId === 3 || agentStatus === 4) {
        const status = await getEventRequestStatus();
        setRequestStatus(status);
      }
    };
    fetchRequestStatus();
  }, [roleId, agentStatus]);



  useEffect(() => {
    const fetchAgentStatus = async () => {
      if (roleId === 1) {
        const status = await getAgentStatus();
        setAgentStatus(status);
      }
    };

    fetchAgentStatus();
  }, [roleId]);
  const isApprovedAgent = roleId === 1 && agentStatus === 4;
  const isGuide = roleId === 2;
  const isHotelOwner = roleId === 3;

  const canRequestEvent = isApprovedAgent || isGuide || isHotelOwner;
  const openPopup = (ticket, eventTitle, eventId) => {
    setSelectedTicket({ ...ticket, eventTitle, eventId });
    setQuantity(1);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedTicket(null);
  };

  const confirmBuy = () => {
    navigate(`/event/${selectedTicket.eventId}`, {
      state: {
        ticketId: selectedTicket.id,
        category: selectedTicket.category,
        price: selectedTicket.price,
        quantity: quantity,
        eventTitle: selectedTicket.eventTitle,
      },
    });

    closePopup();
  };
  const handleDeleteEvent = async (eventId) => {
    if (!window.confirm("Delete this event?")) return;

    try {
      await deleteEvent(eventId);
      setEvents(events.filter((e) => e.id !== eventId));
    } catch (err) {
      alert("Failed to delete event");
      console.error(err);
    }
  };


  return (
    <div className="event-list-container">
      <SEO
        title="Upcoming Sri Lanka Events & Cultural Festivals | Soloway"
        description="Discover and book upcoming cultural events, music festivals, sports gatherings, and seasonal island events across Sri Lanka."
        canonicalPath="/events"
      />
      <NavUser />
      <div className="event-header">  <h1>Upcoming Events</h1></div>

      <div className="event-actions">
        {canRequestEvent && (
          <>
            {!requestStatus && (
              <button
                className="request-event-btn"
                onClick={async () => {
                  await createEventRequest();
                  setRequestStatus({ status_id: 3 });
                }}
              >
                Request to List Event
              </button>
            )}

            {requestStatus?.status_id === 3 && (
              <button className="pending-btn" disabled>
                Pending Approval
              </button>
            )}

            {requestStatus?.status_id === 4 && (
              <button
                className="create-event-btn"
                onClick={() => navigate("/create-event")}
              >
                List Event
              </button>
            )}
            {requestStatus?.status_id === 2 && (
              <div className="rejected-message">
                <p>Your request was rejected by the admin.</p>
                <button
                  className="request-event-btn"
                  onClick={async () => {
                    const res = await createEventRequest();
                    setRequestStatus(res);
                  }}
                >
                  Request Again
                </button>
              </div>
            )}
          </>
        )}

      </div>

      <div className="event-grid">
        {events.length > 0 ? (
          events.map((event) => {
            const isOwner = userId && event.user_id === userId;

            return (
              <div className="event-card" key={event.id}>
                {event.image && <img src={event.image} alt={event.title} />}

                <div className="event-card-content">
                  <h3>{event.title}</h3>
                  <p className="event-description">{event.description}</p>

                  <div className="ticket-section">
                    <h4>Tickets</h4>
                    <div className="ticket-list">
                      {event.tickets?.length ? (
                        event.tickets.map((t) => (
                          <div className="ticket-card" key={t.id}>
                            <div className="ticket-info">
                              <span>{t.category}</span>
                              <span>Rs. {t.price}</span>
                              <span>{t.count} left</span>
                            </div>

                            <button
                              className="buy-ticket-btn"
                              onClick={() =>
                                openPopup(t, event.title, event.id)
                              }
                            >
                              Buy Ticket
                            </button>
                          </div>
                        ))
                      ) : (
                        <p>No tickets available</p>
                      )}
                    </div>
                  </div>

                  <p className="created-at">
                    {new Date(event.created_at).toLocaleString()}
                  </p>

                  {isOwner && (
                    <div className="event-owner-actions">
                      <button
                        className="edit-event-btn"
                        onClick={() => navigate(`/events/edit/${event.id}`)}
                      >
                        Edit
                      </button>
                      <button
                        className="delete-event-btn"
                        onClick={() => handleDeleteEvent(event.id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <p>No events found.</p>
        )}
      </div>


      {showPopup && selectedTicket && (
        <div className="popup-overlay">
          <div className="popup-box">

            <button className="popup-close" onClick={closePopup}>×</button>

            <h3 className="popup-title">{selectedTicket.eventTitle}</h3>

            <div className="popup-details">
              <p><span>Ticket Type:</span> {selectedTicket.category}</p>
              <p><span>Price:</span> Rs. {selectedTicket.price}</p>
            </div>

            <div className="quantity-wrapper">
              <label>Enter Quantity</label>
              <input
                type="number"
                min="1"
                max={selectedTicket.count}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>

            <div className="popup-actions">
              <button className="cancel-btn" onClick={closePopup}>Cancel</button>
              <button className="confirm-btn-event" onClick={confirmBuy}>Confirm</button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default EventList;
